import { render, staticRenderFns } from "./CustomerMtdSalesNumberDisplayer.vue?vue&type=template&id=24cfeb8e"
import script from "./CustomerMtdSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./CustomerMtdSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports